import React, { useMemo } from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useGetApprovalWorkflow } from '@hooks/queries/approval';
import DropdownDecisions from '@components/MediaViewerHeader/components/DropdownDecisions';
import type { DropdownDecisionsType } from '@components/MediaViewerHeader/components/DropdownDecisions/DropdownDecisions';
import ApprovalWorkflowDeadline from '@components/MediaViewerHeader/components/ApprovalWorkflowDeadline';
import ApprovalAssetsListActionMenu from '@components/MediaViewerHeader/components/HeaderReviewerActions/ApprovalAssetsListActionMenu';
import { useCurrentWorkspace } from '@hooks/workspace';
import {
  ApprovalRoutingIcon,
  AwbuttonStatusesDoneIcon,
  AwbuttonStatusesPausedIcon
} from '@icons';

type HeaderReviewerApprovalActionsProps = {
  approvalWorkflowId?: string;
  dropdownDecisionsType?: DropdownDecisionsType;
  password?: string | null;
};

function HeaderReviewerApprovalActions({
  approvalWorkflowId,
  password,
  dropdownDecisionsType = 'approval-assets-list'
}: HeaderReviewerApprovalActionsProps) {
  const navigate = useNavigate();
  const { data } = useGetApprovalWorkflow({
    enabled: false,
    params: {
      password,
      id: approvalWorkflowId || ''
    }
  });
  const approvalWorkflow = data?.approvalWorkflow;
  const [currentWorkspace] = useCurrentWorkspace(false);
  const approvalWorkspace =
    currentWorkspace?.id === data?.approvalWorkflow.workspaceId
      ? currentWorkspace
      : undefined;

  const awIcon = useMemo(() => {
    if (approvalWorkflow?.isPaused)
      return <AwbuttonStatusesPausedIcon className="aw_icon" />;
    if (approvalWorkflow?.isFinished)
      return <AwbuttonStatusesDoneIcon className="aw_icon" />;
    return (
      <>
        <ApprovalRoutingIcon className="aw_icon" />
        <div className="active_dot" />
      </>
    );
  }, [approvalWorkflow]);

  return (
    <div className="media_viewer_actions">
      <ApprovalWorkflowDeadline
        approvalWorkflowId={approvalWorkflowId || ''}
        password={password}
      />
      <ApprovalAssetsListActionMenu
        approvalWorkflowId={approvalWorkflowId}
        password={password}
      />
      {!!approvalWorkflow && !!approvalWorkspace && (
        <Button
          className="media_viewer_btn b-only-icon"
          onClick={() => {
            navigate(
              `/campaigns/approvals/${approvalWorkspace.id}/${approvalWorkflow.campaignId}/${approvalWorkflow.id}`
            );
          }}
        >
          {awIcon}
        </Button>
      )}
      <DropdownDecisions
        type={dropdownDecisionsType}
        password={password}
        approvalWorkflowId={approvalWorkflowId}
      />
    </div>
  );
}

export default HeaderReviewerApprovalActions;
